module.exports = __webpack_public_path__ + "media/flags/ca-71a0575e.svg";